/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { mainChannel, viewChannel } from "../../init/message-hub";
import { PAGES, URL_TO_COOKIE_PRIVACY } from "../../const/constants";

const template = require("./template.pug");

require("./style.scss");

export default Backbone.View.extend({
  className: "bottom-panel",

  events: {
    "click .btn-primary": "acceptCookie",
    "click .overview-link": "details"
  },

  initialize(container, position) {
    this.render(container);
  },

  render(container) {
    this.$el.html(template);
    container.html(this.$el);
    this.hide();
  },

  show() {
    this.$el.show();
  },

  hide() {
    this.$el.hide();
  },

  details(e) {
    e.stopPropagation();
    e.preventDefault();
    window.location = URL_TO_COOKIE_PRIVACY;
  },

  acceptCookie() {
    this.hide();
    mainChannel.request("acceptAllCookies");
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/bottom-info-panel/bottom-info-panel.js